import React from 'react';
import { blockingOf, describeBlocking } from '../util/timeOffUnpaid';

/**
 * Body for the "Approve anyway?" ConfirmModal on the timesheet review pages (TAS-586).
 *
 * Unpaid Time can require the employee's paid time to be used up first; when the API refuses an
 * approval for that (422 PAID_NOT_EXHAUSTED) it names the paid categories still holding time.
 * This shows the server's message and that list, so the approver can decide on one request.
 */
const PaidOverrideDetail: React.FC<{ error: unknown }> = ({ error }) => {
  const blocking = blockingOf(error);
  const message = error instanceof Error && error.message
    ? error.message
    : 'This employee still has paid time off available.';
  return (
    <>
      <div>{message}</div>
      {blocking.length > 0 && (
        <ul style={{ margin: '6px 0 0', paddingLeft: 18 }}>
          {blocking.map((b) => (
            <li key={b.categoryID}>{describeBlocking(b)}</li>
          ))}
        </ul>
      )}
      <div className="cm-detail-sub">
        Approving anyway records your name on the request as overriding the rule.
      </div>
    </>
  );
};

export default PaidOverrideDetail;
